import { useEffect, useState } from 'react';

const InteractiveDesks = ({ desks, output, setIsModalOpen, inputDesk, setIsAvailable, handleDeskChange, arePointsActive, loading }) => {
  const [deskData, setDeskData] = useState({ desk: [] });
  const [isHovering, setIsHovering] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [lastMousePosition, setLastMousePosition] = useState({ x: 0, y: 0 });
  const [scale, setScale] = useState(1.15);
  const [pointSize, setPointSize] = useState(18);
  const [pointFontSize, setPointFontSize] = useState(12);

  useEffect(() => {
    const updatedDesks = desks.map(desk => ({
      ...desk,
      Available: output[desk.ResourceId] !== undefined ? output[desk.ResourceId] : desk.Available
    }));    

    setDeskData({
      desk: updatedDesks.slice(0, 14)
    });
  }, [output, inputDesk, desks]);

  useEffect(() => {
    const updatePointSize = () => {
      if (window.innerWidth <= 500) {
        setPointSize(14);  // For small screens
        setPointFontSize(8);
        setScale(1.6);
      } else if (window.innerWidth <= 1200) {
        setPointSize(16);  // For medium screens 1
        setPointFontSize(10);
        setScale(1.15);
      } else if (window.innerWidth <= 1600) {
        setPointSize(20);  // For medium screens 2
        setPointFontSize(12);
        setScale(1.1);
      } else {
        setPointSize(30);  // Default size
        setPointFontSize(15);
        setScale(1);
      }
    };

    updatePointSize();
    window.addEventListener('resize', updatePointSize);
    return () => window.removeEventListener('resize', updatePointSize);
  }, []);

  const handlePointClick = (point) => {
    handleDeskChange(point.ResourceId);
    setIsAvailable(point.Available)
    setIsModalOpen(true)
  };

  const renderDesks = (deskArray) => {
    const deskButtons = [];
    deskArray.forEach((point, index) => {
      deskButtons.push(
        <button
          disabled={arePointsActive}
          key={index}
          className={`interactive-point ${
            loading 
              ? 'disabled' 
              : (point.Available ? 'available' : 'unavailable')
          }`}
          style={{ left: `calc(${point.x}%)`, top: `calc(${point.y}%)`, position: 'absolute', width: `${pointSize}px`, height: `${pointSize}px`, fontSize: `${pointFontSize}px` }}
          onClick={() => handlePointClick(point)}
        >
          {point.ResourceId}
        </button>
      );
    });
    return deskButtons;
  };

  const handleWheel = (e) => {
    e.preventDefault();
    const zoomSpeed = 0.1;
    let newScale = scale;

    if (e.deltaY < 0) { // Scroll up (Zoom in)
      newScale = Math.min(scale + zoomSpeed, 3);
    } else { // Scroll down (Zoom out)
      newScale = Math.max(scale - zoomSpeed, 0.5);
    }

    const rect = e.currentTarget.getBoundingClientRect();
    const offsetX = ((e.clientX - rect.left) / rect.width) * 100;
    const offsetY = ((e.clientY - rect.top) / rect.height) * 100;
    e.currentTarget.style.transformOrigin = `${offsetX}% ${offsetY}%`;

    setScale(newScale);
  };

  const preventPageScroll = (e) => {
    if (isHovering) {
      e.preventDefault(); // Prevent global scroll
    }
  };

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setLastMousePosition({ x: e.clientX, y: e.clientY });
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;

    const dx = e.clientX - lastMousePosition.x;
    const dy = e.clientY - lastMousePosition.y;

    setPosition(prev => ({
      x: prev.x + dx,
      y: prev.y + dy
    }));

    setLastMousePosition({ x: e.clientX, y: e.clientY });
  };

  const handleMouseUp = () => setIsDragging(false);

  useEffect(() => {
    window.addEventListener('wheel', preventPageScroll, { passive: false });
    return () => {
      window.removeEventListener('wheel', preventPageScroll);
    };
  }, [isHovering]);

  return (
    <div 
      className="app-desks-wrapper" 
      onWheel={handleWheel}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => { 
        setIsHovering(false); 
        handleMouseUp();
      }}
      onMouseMove={handleMouseMove}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
    >
      <div 
        className="app-desks" 
        style={{
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
          width: `90%`,
          height: `90%`,
          transform: `translate(${position.x}px, ${position.y}px) scale(${scale})`,
          transformOrigin: 'center', // Important pour zoomer depuis le centre
          backgroundImage: `url('/images/map/map-web-3.png')`,
          backgroundSize: "contain",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          position: "relative",
          cursor: isDragging ? 'grabbing' : 'grab'
        }}
      >
        {loading && <div className="loading-spinner map-loading-spinner"></div>}
        <div className="desk">
          {renderDesks(deskData.desk)}
        </div>

      </div>
    </div>
  );
};

export default InteractiveDesks;